let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) subscribers[eventName] = [];
  subscribers[eventName] = [...subscribers[eventName], callback];
  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) subscribers[eventName].forEach((callback) => callback(data));
}

function createObserver(options) {
  const threshold = options.threshold ? options.threshold : 0;
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (typeof options.callback === 'function') {
          options.callback();
          observer.unobserve(entry.target);
        }
      }
    });
  }, { rootMargin: `0px 0px ${threshold}px 0px` });
  observer.observe(options.element);
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function getCookie(cname) {
  const name = cname + '=';
  const ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return '';
}

function deleteCookie(name) {
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function convertBreakpoint(breakpoint) {
  let screen;
  switch (breakpoint) {
    case 'small':
      screen = '(max-width: 749px)';
      break;
    case 'medium':
      screen = '(min-width: 750px) and (max-width: 1032px)';
      break;
    case 'large-up':
      screen = '(min-width: 1033px)';
      break;
  }

  return screen
}

function setScrollbarWidth() {
  const scrollbarWidth = window.innerWidth - document.body.clientWidth;
  if (scrollbarWidth > 0) document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
}

function getFocusableElements(container) {
  if (!container) return [];
  return Array.from(container.querySelectorAll([
    'summary',
    'a[href]',
    'button:not([disabled])',
    'input:not([type="hidden"]):not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'area[href]',
    'object',
    'iframe',
    '[contenteditable="true"]',
    '[tabindex]:not([tabindex="-1"])'
  ].join(','))).filter((element) => {
    if (element.hasAttribute('disabled') || element.getAttribute('aria-hidden') === 'true') return false;
    if (element.closest('[hidden], [aria-hidden="true"], [inert]')) return false;
    return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
  });
}

function closeSideDrawer() {
  const sideDrawers = document.querySelectorAll('side-drawer, cart-drawer, pickup-availability-drawer');
  [...sideDrawers].forEach(drawer => drawer.close());
}

function hideModalDialog() {
  const modalDialogs = document.querySelectorAll('modal-dialog, quick-add-modal, quick-view-modal');
  [...modalDialogs].forEach(modal => modal.hide());
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  if (summary.nextElementSibling.getAttribute('id')) summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  summary.addEventListener('click', (event) => event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open')));
  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};
const modalInertState = {
  containers: [],
  restore() {
    this.containers.forEach(({ element, inert }) => {
      if (inert) {
        element.setAttribute('inert', '');
      } else {
        element.removeAttribute('inert');
      }
    });
    this.containers = [];
  }
};

function setModalBackgroundInert(container) {
  modalInertState.restore();
  if (!container) return;
  const activeContainer = container.closest('body > *') || container;
  modalInertState.containers = Array.from(document.body.children)
    .filter((element) => element !== activeContainer && !element.contains(activeContainer))
    .map((element) => ({
      element,
      inert: element.hasAttribute('inert')
    }));
  modalInertState.containers.forEach(({ element }) => element.setAttribute('inert', ''));
}

function getInitialFocusElement(container, elementToFocus = null) {
  if (elementToFocus && elementToFocus.focus) return elementToFocus;
  return container?.querySelector('.drawer__close, .modal__toggle, [id^="ModalClose-"], [id^="MediaLightboxClose-"]') ||
    getFocusableElements(container)[0] ||
    container;
}

function trapFocus(container, elementToFocus = container) {
  if (!container) return;
  removeTrapFocus();
  setModalBackgroundInert(container);

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() === 'ESCAPE') {
      const activeDialog = container.closest('modal-dialog, look-modal-dialog, hotspot-modal-dialog, media-lightbox, side-drawer, cart-drawer, header-drawer, pickup-availability-drawer, look-card');
      activeDialog?.hide?.();
      activeDialog?.close?.();
      return;
    }
    if (event.code.toUpperCase() !== 'TAB') return;
    const elements = getFocusableElements(container);
    if (elements.length === 0) {
      event.preventDefault();
      container.focus();
      return;
    }
    const first = elements[0];
    const last = elements[elements.length - 1];
    if (!container.contains(event.target)) {
      event.preventDefault();
      first.focus();
      return;
    }
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    } else if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  trapFocusHandlers.focusin = (event) => {
    if (container.contains(event.target)) return;
    const elements = getFocusableElements(container);
    (elements[0] || container).focus();
  };

  document.addEventListener('keydown', trapFocusHandlers.keydown);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  const focusElement = getInitialFocusElement(container, elementToFocus);
  if (!focusElement.hasAttribute('tabindex') && !getFocusableElements(container).includes(focusElement)) {
    focusElement.setAttribute('tabindex', '-1');
  }
  requestAnimationFrame(() => focusElement.focus());

  if (focusElement.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(focusElement.type) && focusElement.value) focusElement.setSelectionRange(0, focusElement.value.length);
}
// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
  const opts = Object.defineProperty({}, 'passive', {
    get: () => {
      ThemeSupportsPassive = true;
    }
  });
} catch (e) {
  focusVisiblePolyfill();
}

const onYouTubePromise = new Promise((resolve) => {
  window.onYouTubeIframeAPIReady = () => resolve();
});

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) mouseClick = false;
  });

  window.addEventListener('mousedown', (event) => mouseClick = true);

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
    if (mouseClick) return;
    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');
  }, true);
}

function visibleMedia(media) {
  return Array.from(media).find((item) => {
    const style = window.getComputedStyle(item);
    return style.display !== 'none';
  });
}

function pauseAllMedia() {
  // Pause YouTube videos
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });

  // Request the paused state for Vimeo videos
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"getPaused"}', '*');
  });

  // Add a single event listener for the message event
  window.addEventListener('message', (event) => {
    // Ensure the message is from YouTube
    if (event.origin.includes('youtube.com')) {
      try {
        const data = JSON.parse(event.data);
        if (data.event === 'infoDelivery' && data.info && data.info.playerState !== undefined) {
          const playerState = data.info.playerState;
          const video = event.source.frameElement; // Get the iframe that sent the message

          // If the video is playing (playerState = 1), pause it
          if (playerState === 1) {
            video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            video.classList.add('paused');
          }
        }
      } catch (error) {
        console.error('Error parsing YouTube response:', error);
      }
    }

    // Ensure the message is from Vimeo
    if (event.origin.includes('vimeo.com')) {
      try {
        const data = JSON.parse(event.data);
        if (data.method === 'getPaused') {
          const video = event.source.frameElement; // Get the iframe that sent the message
          if (video && !data.value) { // If the video is playing
            video.contentWindow.postMessage('{"method":"pause"}', '*');
            video.classList.add('paused');
          }
        }
      } catch (error) {
        console.error('Error parsing Vimeo response:', error);
      }
    }
  });

  // Pause all HTML5 video elements (native <video> elements)
  document.querySelectorAll('video').forEach((video) => {
    if (!video.paused && !video.ended) {
      video.pause();
      video.classList.add('paused');
    }
  });

  // Pause 3D models (model-viewer)
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI && model.modelViewerUI.isPaused) {
      model.modelViewerUI.play(); // Assuming modelViewerUI has a play method
      model.classList.add('paused'); // Add 'paused' class to indicate it's paused
    }
  });
}

function playAllPausedMedia() {
  // Play YouTube videos that have the 'paused' class
  document.querySelectorAll('.js-youtube.paused').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    video.classList.remove('paused'); // Remove 'paused' class after playing
  });

  // Request the paused state for Vimeo videos and play if paused (using 'paused' class)
  document.querySelectorAll('.js-vimeo.paused').forEach((video) => {
    video.contentWindow.postMessage('{"method":"getPaused"}', '*');
  });

  // Listen for message events (for Vimeo and YouTube)
  window.addEventListener('message', (event) => {
    if (event.origin.includes('youtube.com')) {
      try {
        const data = JSON.parse(event.data);
        if (data.event === 'infoDelivery' && data.info && data.info.playerState !== undefined) {
          const playerState = data.info.playerState;
          const video = event.source.frameElement; // Get the iframe that sent the message
          if (playerState === 2) { // playerState 2 means paused
            video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            video.classList.remove('paused'); // Optionally remove the paused class
          }
        }
      } catch (error) {
        console.error('Error parsing YouTube response:', error);
      }
    }

    if (event.origin.includes('vimeo.com')) {
      try {
        const data = JSON.parse(event.data);
        if (data.method === 'getPaused') {
          const video = event.source.frameElement;
          if (video && data.value) { // If video is paused (data.value is true)
            video.contentWindow.postMessage('{"method":"play"}', '*');
            video.classList.remove('paused'); // Optionally remove the paused class
          }
        }
      } catch (error) {
        console.error("Error parsing Vimeo response:", error);
      }
    }
  });

  // Play HTML5 video elements that have the 'paused' class
  document.querySelectorAll('video.paused').forEach((video) => {
    video.play();
    video.classList.remove('paused'); // Remove 'paused' class after playing
  });

  // Play 3D models (model-viewer) if they are paused and have the 'paused' class
  document.querySelectorAll('product-model.paused').forEach((model) => {
    if (model.modelViewerUI && model.modelViewerUI.isPaused) {
      model.modelViewerUI.play(); // Assuming modelViewerUI has a play method
      model.classList.remove('paused'); // Remove 'paused' class after playing
    }
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  modalInertState.restore();
  if (elementToFocus && document.contains(elementToFocus)) requestAnimationFrame(() => elementToFocus.focus());
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) return;
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};
  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') cents = cents.replace('.', '');
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || window.shopMoney.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) return 0;
    number = number.toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class CardHoverDistance extends HTMLElement {
  constructor() {
    super();
    this.resizeObserver = new ResizeObserver(() => this.update());
  }

  get breakpoint() {
    return this.dataset.breakpoint || null
  }

  get parent() {
    return this.closest(this.dataset.parent)
  }

  connectedCallback() {
    this.init();
    this.resizeObserver.observe(document.body);
  }

  disconnectedCallback() {
    this.resizeObserver.disconnect();
  }

  init() {
    if (!this.parent || !this.breakpoint) return;
    this.update();
  }

  update() {
    if (!this.parent) return;
    const matches = window.matchMedia(convertBreakpoint(this.breakpoint)).matches;
    if (matches) {
      this.parent.style.setProperty('--card-hover-distance', `${this.offsetHeight}px`);
    } else {
      this.parent.style.removeProperty('--card-hover-distance');
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.init();
    }
  }
}

customElements.define('card-hover-distance', CardHoverDistance);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.onPosterClick = this.onPosterClick.bind(this);
    this.togglePlayPause = this.togglePlayPause.bind(this);
    this.toggleSound = this.toggleSound.bind(this);
  }

  connectedCallback() {
    this.posterElement?.addEventListener('click', this.onPosterClick);
    this.controlElement?.addEventListener('click', this.togglePlayPause);
    this.soundElement?.addEventListener('click', this.toggleSound);

    createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: 0
    });
  }

  disconnectedCallback() {
    this.posterElement?.removeEventListener('click', this.onPosterClick);
    this.controlElement?.removeEventListener('click', this.togglePlayPause);
    this.soundElement?.removeEventListener('click', this.toggleSound);
  }

  static get observedAttributes() {
    return ['playing', 'muted']
  }

  get autoplay() {
    return this.hasAttribute('autoplay')
  }

  get playing() {
    return this.hasAttribute('playing')
  }

  get muted() {
    return this.hasAttribute('muted')
  }

  get posterElement() {
    return this.querySelector('[id^="Deferred-Poster-"]')
  }

  get controlElement() {
    return this.querySelector('.media__control-button')
  }

  get soundElement() {
    return this.querySelector('.media__sound-button')
  }

  get controlledElement() {
    return this.hasAttribute('aria-controls') ? document.getElementById(this.getAttribute('aria-controls')) : null
  }

  get player() {
    return this.playerProxy = this.playerProxy || new Proxy(this.playerTarget(), {
      get: (target, prop) => {
        return async () => {
          target = await target;
          this.playerHandler(target, prop);
        };
      }
    });
  }

  init() {
    if (this.autoplay && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.paused = true;
      this.updateControlButton(true);
      return;
    }
    if (this.autoplay) if (!this.paused) this.play();
  }

  onPosterClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.playing) {
      this.paused = true;
      this.pause();
    } else {
      this.paused = false;
      this.play();
    }
  }

  togglePlayPause(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.playing) {
      this.paused = true;
      this.pause();
    } else {
      this.paused = false;
      this.play();
    }
    this.updateControlButton(this.paused);
  }

  toggleSound(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.muted) {
      this.soundOn();
    } else {
      this.soundOff();
    }
    this.updateSoundButton(this.muted);
  }

  // attributeChangedCallback(name, oldValue, newValue) {
  //   if (name === 'playing') {
  //     if (oldValue === null && newValue === '') {
  //       this.dispatchEvent(new CustomEvent('video:play', { bubbles: true }));
  //       this.paused = false;
  //     } else if (newValue === null) {
  //       this.dispatchEvent(new CustomEvent('video:pause', { bubbles: true }));
  //       this.paused = true;
  //     }
  //   }
  //   if (name === 'muted') {
  //     if (oldValue === null && newValue === '') {
  //       this.dispatchEvent(new CustomEvent('video:muted', { bubbles: true }));
  //     } else if (newValue === null) {
  //       this.dispatchEvent(new CustomEvent('video:unmuted', { bubbles: true }));
  //     }
  //   }
  // }

  play() {
    if (!this.playing) this.player.play();
  }

  pause() {
    if (this.playing) this.player.pause();
  }

  soundOff() {
    if (!this.muted) {
      this.setAttribute('muted', '');
      this.player.muted();
    }
  }

  soundOn() {
    if (this.muted) {
      this.removeAttribute('muted');
      this.player.unmuted();
    }
  }

  updateControlButton(paused = false) {
    this.controlElement?.classList.toggle('is-pause', paused);
    this.controlElement?.classList.toggle('is-play', !paused);
    if (this.controlElement) {
      const label = paused ? this.controlElement.dataset.playLabel : this.controlElement.dataset.pauseLabel;
      if (label) this.controlElement.setAttribute('aria-label', label);
    }
  }

  updateSoundButton(muted = false) {
    this.soundElement?.classList.toggle('is-muted', muted);
    this.soundElement?.classList.toggle('is-unmuted', !muted);
    if (this.soundElement) {
      const label = muted ? this.soundElement.dataset.mutedLabel : this.soundElement.dataset.unmutedLabel;
      if (label) this.soundElement.setAttribute('aria-label', label);
    }
  }
}

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this._open = this.details.hasAttribute('open');
    this.onSummaryClick = this.onSummaryClick.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onResize = this.onResize.bind(this);
  }

  get open() {
    return this._open
  }

  set open(value) {
    value = Boolean(value);
    if (value !== this._open) {
      this._open = value;
      if (value) {
        this.details.setAttribute('open', '');
      } else {
        this.details.removeAttribute('open');
      }

      // if (this.isConnected) {
      //   this.transition(value);
      // }
    }

    this.details.setAttribute('aria-expanded', value ? 'true' : 'false');
    this.dispatchEvent(new CustomEvent('toggle', { bubbles: true, detail: { current: this } }));
  }

  get details() {
    return this._details || this.querySelector('details')
  }

  get summaryElement() {
    return this._summaryElement || this.querySelector('summary')
  }

  get contentElement() {
    return this._contentElement || this.querySelector('summary + *')
  }

  get state() {
    return this.details.hasAttribute('open')
  }

  get breakpoint() {
    return this.dataset.breakpoint
  }

  connectedCallback() {
    this.onInitilize();
    this.summaryElement?.addEventListener('click', this.onSummaryClick);
    this.details.addEventListener('keyup', this.onKeyUp);
    window.addEventListener('resize', this.onResize);
  }

  disconnectedCallback() {
    this.summaryElement?.removeEventListener('click', this.onSummaryClick);
    this.details.removeEventListener('keyup', this.onKeyUp);
    window.removeEventListener('resize', this.onResize);
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.toggle();
  }

  toggle(forceState = !this.open) {
    this.open = forceState;
  }

  openDetails() {
    this.open = true;
  }

  closeDetails() {
    this.open = false;
  }

  onInitilize() {
    this.update();
  }

  update() {
    if (this.breakpoint == 'all' || this.breakpoint == undefined) return;
    if (!window.matchMedia(convertBreakpoint(this.breakpoint)).matches) {
      this.openDetails();
    } else if (this.dataset.open == undefined) {
      this.closeDetails();
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() === 'ESCAPE') {
      this.closeDetails();
    }
  }

  onResize() {
    this.update();
  }

  async transition(isOpening) {
    const startHeight = this.details.offsetHeight;
    const endHeight = isOpening ? this.summaryElement.offsetHeight + this.contentElement.scrollHeight : this.summaryElement.offsetHeight;
    this.details.style.overflow = 'hidden';
    this.details.style.height = `${startHeight}px`;
    if (isOpening) {
      this.details.setAttribute('open', '');
      this.contentElement.style.opacity = 0;
      this.contentElement.style.transform = 'translateY(10px)';
    }

    const animation = this.details.animate([
      { height: `${startHeight}px`, offset: 0 },
      { height: `${endHeight}px`, offset: 1 }
    ], {
      duration: 300,
      easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
      fill: 'both'
    });

    const contentAnimation = this.contentElement.animate(
      isOpening
        ? [
          { opacity: 0, transform: 'translateY(10px)', offset: 0 },
          { opacity: 1, transform: 'translateY(0)', offset: 1 }
        ]
        : [
          { opacity: 1, transform: 'translateY(0)', offset: 0 },
          { opacity: 0, transform: 'translateY(10px)', offset: 1 }
        ],
      {
        duration: 200,
        easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
        fill: 'both',
        delay: isOpening ? 100 : 0
      }
    );

    await Promise.all([animation.finished, contentAnimation.finished]);
    if (!isOpening) this.details.removeAttribute('open');
    this.details.style.height = 'auto';
    this.details.style.overflow = 'visible';
    this.contentElement.style.opacity = '';
    this.contentElement.style.transform = '';
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class DetailsDisclosures extends HTMLElement {
  constructor() {
    super();
    this._onToggle = this._onToggle.bind(this);
  }

  connectedCallback() {
    if (!this.onlyOne) return;
    this.enforceSingleOpen();
    this.observeDetails();
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
    if (this.observer) this.observer.disconnect();
  }

  get onlyOne() {
    return this.hasAttribute('only-one');
  }

  get allDetailsDisclosure() {
    return this._allDetailsDisclosure = Array.from(this.querySelectorAll('details-disclosure'));
  }

  addEventListeners() {
    this.allDetailsDisclosure.forEach(detailsDisclosure => detailsDisclosure.addEventListener('toggle', this._onToggle));
  }

  removeEventListeners() {
    if (!this._allDetailsDisclosure) return;
    this._allDetailsDisclosure.forEach(detailsDisclosure => detailsDisclosure.removeEventListener('toggle', this._onToggle));
  }

  _onToggle(event) {
    const current = event.currentTarget;
    if (!current.open || !this.onlyOne) return;
    this.allDetailsDisclosure.forEach(detailsDisclosure => {
      if (detailsDisclosure !== current) {
        requestAnimationFrame(() => detailsDisclosure.toggle(false));
      }
    });
  }

  enforceSingleOpen() {
    let firstOpenFound = false;
    this.allDetailsDisclosure.forEach(detailsDisclosure => {
      if (detailsDisclosure.open) {
        if (!firstOpenFound) {
          firstOpenFound = true;
        } else {
          detailsDisclosure.toggle(false);
        }
      }
    });
  }

  observeDetails() {
    this.observer = new MutationObserver(() => {
      this.removeEventListeners();
      this._allDetailsDisclosure = null;
      this.enforceSingleOpen();
      this.addEventListeners();
    });

    this.observer.observe(this, { childList: true, subtree: true });
  }
}

customElements.define('details-disclosures', DetailsDisclosures);

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.activeElement = event.relatedTarget || this.summaryToggle;
    this.detailsContainer.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    closeSideDrawer();
    trapFocus(this.detailsContainer, this.detailsContainer.querySelector('input:not([type="hidden"])') || this.summaryToggle);
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.activeElement || this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);

class ImageAnimation extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: 0
    });
  }

  init() {
    this.setAttribute('loaded', true);
  }
}

customElements.define('image-animation', ImageAnimation);

class LoadingOverlay extends HTMLElement {
  constructor() {
    super();
  }

  enableLoading() {
    this.classList.remove('hidden');
    this.querySelector('[aria-hidden]')?.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    this.classList.add('hidden');
    this.querySelector('[aria-hidden]')?.setAttribute('aria-hidden', true);
  }
}

customElements.define('loading-overlay', LoadingOverlay);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.delay = 0;
    this.animate = false;
    this.handleResize = this.handleResize.bind(this);
    this.bindEvents();
  }

  static get observedAttributes() {
    return ['breakpoint'];
  }

  get button() {
    return this.querySelector('[id^="ModalClose-"]');
  }

  get overlay() {
    return this.querySelector('[id^="Modal-Overlay-"]');
  }

  get breakpoint() {
    return this.getAttribute('breakpoint')
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.elements = Array.from(document.body.children).filter(element => element.id == this.getAttribute('id'));
    this.elements.length > 0 ? this.remove() : document.body.appendChild(this);
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
  }

  bindEvents() {
    this.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.hide());
    this.overlay?.addEventListener('click', this.hide.bind(this, false));
    this.button?.addEventListener('click', this.hide.bind(this, false));
  }

  handleResize() {
    if (!this.breakpoint) return;
    if (!window.matchMedia(this.breakpoint).matches && this.hasAttribute('open')) {
      console.warn(`Modal hidden on resize: breakpoint "${this.breakpoint}" no longer matches.`);
      this.hide();
    }
  }

  loadContent() {
    const templatePopup = this.querySelector('.template-popup');
    if (!templatePopup) return;
    if (!this.getAttribute('loaded')) {
      templatePopup.replaceWith(templatePopup.content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);
    }
  }
lockScroll() {
  const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
  document.documentElement.dataset.scrollY = scrollY;
  document.documentElement.style.setProperty('--lock-top', `-${scrollY}px`);
  document.documentElement.style.scrollBehavior = 'auto';
  document.body.classList.add('is-locked');
}

unlockScroll() {
  const scrollY = parseInt(document.documentElement.dataset.scrollY || '0', 10);
  document.body.classList.remove('is-locked');
  document.documentElement.style.removeProperty('--lock-top');
  window.scrollTo(0, scrollY);
  document.documentElement.style.scrollBehavior = '';
}


  show(triggeredBy) {
    // Conditionally check breakpoint only if it's defined
    if (this.breakpoint && !window.matchMedia(this.breakpoint).matches) {
      console.warn('Modal display suppressed due to active breakpoint.');
      return;
    }
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.loadContent();
    setTimeout(() => {
      this.setAttribute('open', '');
      this.classList.add('animate', 'active');
      this.querySelector('.modal__content')?.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      setScrollbarWidth();
      document.body.classList.add('modal-show', 'overflow-hidden');
      trapFocus(this, this.querySelector('.modal__toggle, [id^="ModalClose-"], [role="dialog"]'));
    }, this.delay);
    document.body.dispatchEvent(new CustomEvent('modalOpened'));
    window.pauseAllMedia();
    document.body.classList.add('drawer-show');
    this.lockScroll();
  }

  hide() {
    this.removeAttribute('open');
    this.classList.remove('animate', 'active');
    document.body.classList.remove('modal-show', 'overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    removeTrapFocus(this.activeElement);
    window.playAllPausedMedia();
    document.body.classList.remove('drawer-show');
    this.unlockScroll();
  }

  setActiveElement(element) {
    if (!element) return;
    this.activeElement = element;
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (name === 'breakpoint' && this.hasAttribute('open')) {
      // Close modal if new breakpoint no longer matches
      if (!window.matchMedia(newVal).matches) {
        this.hide();
      }
    }
  }
}

customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}

customElements.define('modal-opener', ModalOpener);

class MoreLessLayout extends HTMLElement {
  constructor() {
    super();
    this.content = this.querySelector(".more-less-layout__content");
    this.button = this.querySelector("button");
    this.readMoreText = this.getAttribute("data-read-more-text") || "Read More";
    this.readLessText = this.getAttribute("data-read-less-text") || "Read Less";
    this.maxLinesDesktop = parseInt(this.getAttribute("data-max-lines-desktop"), 10) || 3;
    this.maxLinesMobile = parseInt(this.getAttribute("data-max-lines-mobile"), 10) || 2;
    this.expanded = false;
    this.updateStyles();
    this.checkButtonVisibility();
    this.button.addEventListener("click", () => this.toggleReadMore());
  }

  updateStyles() {
    this.content.style.display = "-webkit-box";
    this.content.style.overflow = "hidden";
    this.content.style.webkitBoxOrient = "vertical";
    this.content.style.webkitLineClamp = this.getMaxLines();
  }

  getMaxLines() {
    return window.matchMedia('(min-width: 1033px)').matches ? this.maxLinesDesktop : this.maxLinesMobile
  }

  toggleReadMore() {
    if (this.expanded) {
      this.content.style.webkitLineClamp = this.getMaxLines();
      this.button.querySelector('span:not(.icon)').textContent = this.readMoreText;
    } else {
      this.content.style.webkitLineClamp = "unset";
      this.button.querySelector('span:not(.icon)').textContent = this.readLessText;
    }
    this.classList.toggle('expanded', !this.expanded);
    this.expanded = !this.expanded;
  }

  checkButtonVisibility() {
    const fullLines = this.getFullLineCount();
    const maxLines = this.getMaxLines();
    this.button.closest('.more-less-layout__button').classList.toggle('hidden', fullLines <= maxLines);
  }

  getFullLineCount() {
    const style = window.getComputedStyle(this.content);
    const lineHeight = parseFloat(style.lineHeight);
    const fullHeight = this.content.scrollHeight;
    return Math.round(fullHeight / lineHeight);
  }

  connectedCallback() {
    window.addEventListener('resize', () => {
      if (!this.expanded) {
        this.updateStyles();
        this.checkButtonVisibility();
      }
    });
  }
}

customElements.define('more-less-layout', MoreLessLayout);

class OverflowList extends HTMLElement {
  constructor() {
    super();

    this._reflowFrameId = null;
    this.lastDimensions = { width: null, height: null };
    this.handleChange = this.handleChange.bind(this);
    this.reflowItems = this.reflowItems.bind(this);
    this.resizeObserver = new ResizeObserver(this.handleChange);
    this.mutationObserver = new MutationObserver(this.handleChange);
    this.refs = {};
  }

  static get observedAttributes() {
    return ['disabled', 'minimum-items'];
  }

  get minimumItems() {
    const value = this.getAttribute('minimum-items');
    return value ? parseInt(value, 10) : null;
  }

  get defaultSlot() {
    return this.refs?.defaultSlot;
  }

  get overflowSlot() {
    return this.refs?.overflowSlot;
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'disabled') {
      newValue === 'true' ? this.reset() : this.requestReflow();
    }
  }

  connectedCallback() {
    if (!this.shadowRoot) this.initializeShadowRoot();
    this.collectShadowRefs();
    this.addEventListener('reflow', (event) => this.requestReflow(event.detail?.lastVisibleElement));
    this.requestReflow();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.mutationObserver?.disconnect();
    if (this._reflowFrameId !== null) {
      cancelAnimationFrame(this._reflowFrameId);
      this._reflowFrameId = null;
    }
  }

  initializeShadowRoot() {
    const template = this.querySelector(':scope > template');
    if (!(template instanceof HTMLTemplateElement)) return;
    const shadow = this.attachShadow({ mode: 'open' });
    shadow.append(template.content.cloneNode(true));
    template.remove();
  }

  collectShadowRefs() {
    const shadowRoot = this.shadowRoot;
    if (!shadowRoot) throw new Error('Missing shadow root');
    const defaultSlot = shadowRoot.querySelector('slot:not([name])');
    const overflowSlot = shadowRoot.querySelector('slot[name="overflow"]');
    const moreSlot = shadowRoot.querySelector('slot[name="more"]');
    const overflow = shadowRoot.querySelector('[part="overflow"]');
    const list = shadowRoot.querySelector('[part="list"]');
    const placeholder = shadowRoot.querySelector('[part="placeholder"]');
    if (!(defaultSlot instanceof HTMLSlotElement) || !(overflowSlot instanceof HTMLSlotElement) || !(moreSlot instanceof HTMLSlotElement) || !(overflow instanceof HTMLElement) || !(list instanceof HTMLUListElement) || !(placeholder instanceof HTMLLIElement)) {
      throw new Error('Invalid element types in <OverflowList />');
    }
    this.refs = { defaultSlot, overflowSlot, moreSlot, overflow, list, placeholder };
  }

  handleChange(entries) {
    let width = null;
    let height = null;

    for (const entry of entries) {
      if (entry instanceof ResizeObserverEntry) {
        width = Math.round(entry.contentRect.width);
        height = Math.round(entry.contentRect.height);
      }
    }
    // Skip reflow if dimensions are 0 or the same as the last reflow
    const changed = width !== this.lastDimensions.width || height !== this.lastDimensions.height;
    if (changed) {
      this.lastDimensions = { width, height };
      this.requestReflow();
    }
  }

  requestReflow(lastVisibleElement = null) {
    if (this._reflowFrameId !== null) cancelAnimationFrame(this._reflowFrameId);
    this._reflowFrameId = requestAnimationFrame(() => {
      this._reflowFrameId = null;
      this.reflowItems(lastVisibleElement);
    });
  }

  moveItemsToDefaultSlot() {
    const { defaultSlot, overflowSlot } = this.refs;
    for (const element of overflowSlot.assignedElements()) {
      element.slot = defaultSlot.name;
    }
  }

  reset() {
    const { list } = this.refs;
    this.resizeObserver?.disconnect();
    this.mutationObserver?.disconnect();
    this.moveItemsToDefaultSlot();
    list.style.removeProperty('height');
    this.style.setProperty('--overflow-count', '0');
  }

  updateMinimumReached(visibleElements) {
    if (this.minimumItems !== null) {
      const minimumReached = visibleElements.length < this.minimumItems;
      this.toggleAttribute('minimum-reached', minimumReached);
      this.dispatchEvent(new CustomEvent('overflow-minimum', {
        detail: { minimumReached },
        bubbles: true
      }));
    }
  }

  showAll() {
    const { placeholder } = this.refs;
    placeholder.style.setProperty('width', '0');
    placeholder.style.setProperty('display', 'none');
    this.setAttribute('disabled', 'true');
  }

  reflowItems(lastVisibleElement = null) {
    const { defaultSlot, overflowSlot, moreSlot, list, placeholder } = this.refs;
    this.resizeObserver?.disconnect();
    this.mutationObserver?.disconnect();
    // Avoid layout shifts while reflowing the list
    const { height } = this.firstElementChild?.getBoundingClientRect() ?? {};
    if (height) list.style.height = `${height}px`;
    list.style.setProperty('overflow', 'hidden');
    // Move all elements to the default slot so we can check which ones overflow
    this.moveItemsToDefaultSlot();
    const elements = defaultSlot.assignedElements();
    moreSlot.hidden = true;
    placeholder.hidden = true;
    const listRect = list.getBoundingClientRect();
    // Store the initial dimensions for comparison later
    this.lastDimensions = { width: Math.round(listRect.width), height: Math.round(listRect.height) };
    const getVisibleElements = () => {
      return elements.filter(element => {
        const rect = element.getBoundingClientRect();
        return rect.top <= listRect.top + 1
      });
    };
    let visibleElements = getVisibleElements();
    // If not all items fit or we have a lastVisibleElement, let's calculate with "More" button
    if (visibleElements.length < elements.length || lastVisibleElement) {
      // Putting the "More" item (and lastVisibleElement, if provided) at the start of the list lets us see which items will fit on the same row
      moreSlot.style.setProperty('order', '-1');
      moreSlot.hidden = false;
      moreSlot.style.setProperty('height', `${height}px`);
      if (lastVisibleElement) lastVisibleElement.style.setProperty('order', '-1');
      // Recalculate the visible elements
      visibleElements = getVisibleElements();
      // Reset the order
      moreSlot.style.removeProperty('order');
      if (lastVisibleElement) lastVisibleElement.style.removeProperty('order');
      // If we have a lastVisibleElement, ensure it's in the last visible position
      if (lastVisibleElement && visibleElements.includes(lastVisibleElement)) {
        visibleElements = visibleElements.filter(element => element !== lastVisibleElement);
        visibleElements.push(lastVisibleElement);
      }
      moreSlot.style.setProperty('height', 'auto');
    }

    const overflowingElements = elements.filter(element => !visibleElements.includes(element));
    const [firstOverflowingElement] = overflowingElements;
    const hasOverflow = overflowingElements.length > 0;
    const placeholderWidth = firstOverflowingElement ? firstOverflowingElement.clientWidth : 0;
    // Move the elements to the correct slot
    for (const element of elements) {
      element.slot = overflowingElements.includes(element) ? overflowSlot.name : defaultSlot.name;
    }
    // If there are overflowing elements
    // Show more button and placeholder if needed
    moreSlot.hidden = !hasOverflow;
    if (hasOverflow) {
      // Set the width and height of the placeholder so the list can grow if there is space
      placeholder.style.width = `${placeholderWidth}px`;
      placeholder.hidden = false;
    }

    list.style.setProperty('counter-reset', `overflow-count ${overflowingElements.length}`);
    this.style.setProperty('--overflow-count', `${overflowingElements.length}`);
    list.style.removeProperty('overflow');
    // Check if the minimum-reached state should be updated
    hasOverflow && this.updateMinimumReached(visibleElements);
    // Observe the list for changes in size
    this.resizeObserver.observe(this);
    this.mutationObserver.observe(this, { childList: true });
  }
}

customElements.define('overflow-list', OverflowList);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    button.addEventListener('click', this.expandShowMore.bind(this));
  }

  expandShowMore(event) {
    const button = event.currentTarget;
    const parent = button.closest('.parent-wrap');
    button.classList.toggle('show');
    button.querySelector('span').innerText = button.classList.contains('show') ? button.dataset.showLessText : button.dataset.showMoreText;
    parent.querySelectorAll('.show-more-item').forEach(item => item.classList.toggle('hidden'))
  }
}

customElements.define('show-more-button', ShowMoreButton);

class SideDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
  }

  get overlay() {
    return this.querySelector('[id^="Drawer-Overlay-"]');
  }

  connectedCallback() {
    this.bindEvents();
    if (this.moved) return;
    this.moved = true;
    this.elements = Array.from(document.body.children).filter(element => element.id == this.getAttribute('id'));
    this.elements.length > 0 ? this.remove() : document.body.appendChild(this);
  }

  bindEvents() {
    this.overlay.addEventListener('click', this.close.bind(this));
  }

  loadContent() {
    const templateDrawer = this.querySelector('.template-drawer');
    if (!templateDrawer) return;
    if (!this.getAttribute('loaded')) {
      templateDrawer.replaceWith(templateDrawer.content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    if (this.activeElement) this.activeElement.setAttribute('open', '');
    this.removeAttribute('inert');
    this.loadContent();
    const dialog = this.querySelector('[role="dialog"]') || this.querySelector('.drawer__inner');
    if (dialog) {
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      if (!dialog.hasAttribute('aria-label') && !dialog.hasAttribute('aria-labelledby')) {
        const heading = dialog.querySelector('.drawer__heading, h1, h2, h3');
        if (heading) {
          if (!heading.id) heading.id = `${this.id || 'Drawer'}-heading`;
          dialog.setAttribute('aria-labelledby', heading.id);
        }
      }
      if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');
    }
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      trapFocus(this, this.querySelector('.drawer__close') || dialog);
      setScrollbarWidth();
    });
    this.addEventListener('transitionend', () => {
      if (!this.classList.contains('active')) return;
      const containerToTrapFocusOn = this;
      const focusElement = this.querySelector('.drawer__close') || this.querySelector('.drawer__inner');
      trapFocus(containerToTrapFocusOn, focusElement);
      setScrollbarWidth();
    }, { once: true });
    document.body.classList.add('drawer-show');
  }

  close() {
    this.classList.remove('animate', 'active');
    if (this.activeElement) this.activeElement.removeAttribute('open');
    const elementToFocus = this.getReturnFocusElement();
    removeTrapFocus(elementToFocus);
    this.setAttribute('inert', '');
    document.body.classList.remove('drawer-show');
  }

  setActiveElement(element) {
    if (!element) return;
    if (this.contains(element) && this.activeElement && !this.contains(this.activeElement)) return;
    this.activeElement = element;
  }

  getReturnFocusElement() {
    if (this.activeElement && document.contains(this.activeElement) && !this.contains(this.activeElement)) {
      return this.activeElement;
    }
    return document.querySelector('side-drawer-opener[data-side-drawer="#' + this.id + '"] button') ||
      document.querySelector('[aria-controls="' + this.id + '"]') ||
      null;
  }
}

customElements.define('side-drawer', SideDrawer);

class SideDrawerOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    let _target = event.currentTarget;
    const drawer = document.querySelector(this.getAttribute('data-side-drawer'));
    drawer && (_target.hasAttribute('open') ? drawer.close() : drawer.open(_target));
  }
}

customElements.define('side-drawer-opener', SideDrawerOpener);

class ThemeSwiper extends HTMLElement {
  constructor() {
    super();
    this._onVideoEnded = null;
    this.lastOutIndex = null;
    this.swiper = null;
    this.breakpointList = ['small', 'medium', 'large-up'];
    this.boundPlaySlider = this.playSlider.bind(this);
    this.boundPauseSlider = this.pauseSlider.bind(this);
  }

  get container() {
    return this._container = this._container || this.querySelector('[data-swiper-container]') || this.querySelector('.swiper')
  }

  get wrapper() {
    return this._wrapper = this._wrapper || this.querySelector('[data-swiper-wrapper]') || this.querySelector('.swiper-wrapper')
  }

  get scrollbar() {
    return document.querySelector(`#Scrollbar-Slider-${this.dataset.sliderId}`) || this.querySelector('.swiper-scrollbar')
  }

  get pagination() {
    return document.querySelector(`#Pagination-Slider-${this.dataset.sliderId}`)
  }

  get prev() {
    return document.querySelector(`#Navigation-Slider-${this.dataset.sliderId} .swiper-button-prev`) || this.querySelector('.swiper-button-prev')
  }

  get next() {
    return document.querySelector(`#Navigation-Slider-${this.dataset.sliderId} .swiper-button-next`) || this.querySelector('.swiper-button-next')
  }

  get playButton() {
    return this.querySelector('.swiper-button-play')
  }

  get pauseButton() {
    return this.querySelector('.swiper-button-pause')
  }

  get resolution() {
    return this.getAttribute('data-resolution')
  }

  get autoplayDelayTime() {
    return parseInt(this.getAttribute('data-autoplay-delay'))
  }

  get items() {
    return this._items = this._items || Array.from(this.querySelectorAll('.swiper-slide'));
  }

  get markedItem() {
    return this._markedItem = this._markedItem || this.querySelector('.swiper-slide.swiper-slide-active [data-marked]');
  }

  get mainGallery() {
    const id = this.dataset.mainGallery;
    if (!id) return null;
    return document.getElementById(id);
  }

  connectedCallback() {
    if (!this.getAttribute('loaded')) {
      createObserver({
        element: this,
        callback: this.init.bind(this),
        threshold: -200
      });
    } else {
      this.init();
    }
    this.playButton?.addEventListener('click', this.boundPlaySlider);
    this.pauseButton?.addEventListener('click', this.boundPauseSlider);

    if (this.resolution) {
      const mq = window.matchMedia(this.resolution);
      this._resolutionListener = () => this.init();
      mq.addEventListener('change', this._resolutionListener);
    }
  }

  disconnectedCallback() {
    this.playButton?.removeEventListener('click', this.boundPlaySlider);
    this.pauseButton?.removeEventListener('click', this.boundPauseSlider);

    if (this.resolution && this._resolutionListener) {
      const mq = window.matchMedia(this.resolution);
      mq.removeEventListener('change', this._resolutionListener);
      this._resolutionListener = null;
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.swiper?.update();
    }
  }

  init() {
    this.options = this.swiperOptions();
    if (this.resolution != undefined) {
      if (window.matchMedia(this.resolution).matches) {
        if (!this.swiper) this.swiperInitilize();
      } else {
        if (this.swiper) this.swiperDestroy();
      }
    } else {
      if (!this.swiper) this.swiperInitilize();
    }
  }

  bindEvents() {
    if (!this.swiper) return;

    this._onSlideChange = () => {
      this.swiper.pagination.render();
      this.swiper.pagination.update();
      this.swiper.navigation.destroy();
      this.swiper.navigation.init();

      const current = this.swiper.realIndex ?? this.swiper.activeIndex;
      this.activateItemByIndex(current);

      this.dispatchEvent(new CustomEvent('slider:change', {
        bubbles: true,
        detail: { currentPage: this.swiper.activeIndex }
      }));
    };

    this._onTransitionStart = () => {
      const oldIndex = this.swiper.previousIndex !== this.swiper.activeIndex
        ? this.swiper.previousIndex
        : this.lastOutIndex;
      const oldSlide = this.swiper.slides[oldIndex];
      if (oldSlide?.dataset.type === 'video') this.handleVideoOut(oldSlide, this.swiper);
      this.swiper.mousewheel.enabled = false;
      this.lastOutIndex = this.swiper.previousIndex;
    };

    this._onTransitionEnd = () => {
      const newSlide = this.swiper.slides[this.swiper.activeIndex];
      if (newSlide?.dataset.type === 'video') this.handleVideoIn(newSlide, this.swiper);
      this.swiper.mousewheel.enabled = true;
      this.lastOutIndex = this.swiper.activeIndex;
    };

    this._onPaginationUpdate = () => this.updatePagination(this.swiper);
    this._onSlideChangeTransitionEnd = () => this.handleLoop(this.swiper);

    this.swiper.on('slideChange', this._onSlideChange);
    this.swiper.on('transitionStart', this._onTransitionStart);
    this.swiper.on('transitionEnd', this._onTransitionEnd);
    this.swiper.on('paginationUpdate', this._onPaginationUpdate);
    this.swiper.on('slideChangeTransitionEnd', this._onSlideChangeTransitionEnd);
  }

  activateItemByIndex(index) {
    const mainSwiper = this.mainGallery;
    if (mainSwiper) {
      mainSwiper.swiper.slideTo(index);
    }
  }

  unBindEvents() {
    if (!this.swiper) return;

    this.swiper.off('slideChange', this._onSlideChange);
    this.swiper.off('transitionStart', this._onTransitionStart);
    this.swiper.off('transitionEnd', this._onTransitionEnd);
    this.swiper.off('paginationUpdate', this._onPaginationUpdate);
    this.swiper.off('slideChangeTransitionEnd', this._onSlideChangeTransitionEnd);

    this._onSlideChange = null;
    this._onTransitionStart = null;
    this._onTransitionEnd = null;
    this._onPaginationUpdate = null;
    this._onSlideChangeTransitionEnd = null;

    if (Shopify.designMode && this._onBlockSelect) {
      this.removeEventListener('shopify:block:select', this._onBlockSelect);
      this._onBlockSelect = null;
    }

    this.lastOutIndex = null;
  }

  swiperOptions() {
    let defaultOptions = {};
    try {
      defaultOptions = JSON.parse(this.dataset.swiper || '{}');
    } catch (e) {
      console.error('Invalid JSON in data-swiper:', e);
    }
    let options = { ...defaultOptions };
    options = {
      ...options,
      pagination: {
        el: this.pagination,
        clickable: true,
        renderBullet: (index, className) => {
          return `<span class="${className}">${index + 1}</span>`;
        }
      },
      navigation: {
        prevEl: this.prev,
        nextEl: this.next
      },
      scrollbar: {
        el: this.scrollbar,
        hide: false
      },
      a11y: {
        enabled: true
      },
      on: {
        init: (element) => {
          const selectedElement = element.slides[element.activeIndex];
          if (selectedElement && selectedElement.dataset.type === 'video') this.handleVideoIn(selectedElement, element);
          const indexInit = this.dataset.activeIndexInit;
          indexInit && this.setActiveSlideItem(indexInit);
          this.setSlideHeight();
          this.checkNavigation(element);
          this.checkPagination(element);
          this.updatePagination(element);
          element.slides.forEach((slide, index) => slide.setAttribute('data-index', index));
        },
        resize: (element) => {
          this.setSlideHeight();
          this.checkNavigation(element);
          this.checkPagination(element);
        },
        update: (element) => {
          this.setSlideHeight();
          this.checkNavigation(element);
          this.checkPagination(element);
        }
      }
    }

    return options
  }

  swiperInitilize() {
    if (!this.container.classList.contains('swiper')) this.container.classList.add('swiper');
    if (!this.wrapper.classList.contains('swiper-wrapper')) this.wrapper.classList.add('swiper-wrapper');
    this.querySelectorAll('[data-swiper-slide]').forEach((element) => {
      if (!element.classList.contains('swiper-slide')) element.classList.add('swiper-slide')
    });
    this.swiper = new Swiper(this.container, this.options);
    this.bindEvents();
  }

  swiperDestroy() {
    this.unBindEvents();
    this.swiper?.destroy(true, true);
    this.swiper = null;
    if (this.container.classList.contains('swiper')) this.container.classList.remove('swiper');
    if (this.wrapper.classList.contains('swiper-wrapper')) this.wrapper.classList.remove('swiper-wrapper');
    this.querySelectorAll('[data-swiper-slide]').forEach((element) => {
      if (element.classList.contains('swiper-slide')) element.classList.remove('swiper-slide')
    });
  }

  setActiveSlideItem(activeIndex) {
    if (typeof activeIndex == undefined) return;
    this.swiper && this.swiper.slideTo(activeIndex);
  }

  setSlideHeight() {
    if (!this.markedItem) return;
    this.style.setProperty('--slide-height', `${this.markedItem.offsetHeight}px`);
  }

  handleLoop(swiper) {
    if (swiper && swiper.params.loop) swiper.loopFix();
  }

  handleVideoOut(oldElement, swiper) {
    if (!oldElement) return;
    const videoElement = window.visibleMedia(oldElement.querySelectorAll('video-media'));
    if (!videoElement) return;
    videoElement.pause();
    videoElement.updateControlButton(true);
    videoElement.updateSoundButton(true);
    if (this._onVideoEnded) {
      videoElement.removeEventListener('video:ended', this._onVideoEnded);
      this._onVideoEnded = null;
    }
  }

  handleVideoIn(newElement, swiper) {
    if (!newElement) return;
    const videoElement = window.visibleMedia(newElement.querySelectorAll('video-media'));
    if (!videoElement) return;
    if (swiper.params.autoplay.enabled && swiper.autoplay.running) {
      // swiper.params.autoplay.delay = 0;
      swiper.autoplay.stop();
    }
    videoElement.play();
    videoElement.updateControlButton(false);
    videoElement.updateSoundButton(false);
    const handleVideoEnd = () => {
      this._onVideoEnded = null;
      videoElement.removeEventListener('video:ended', handleVideoEnd);
      if (swiper.params.autoplay.enabled && !swiper.autoplay.running) {
        swiper.autoplay.start();
        //  swiper.params.autoplay.delay = this.autoplayDelayTime;
        // swiper.slideNext();
      }
    };
    this._onVideoEnded = handleVideoEnd;
    videoElement.addEventListener('video:ended', this._onVideoEnded);
  }

  handleTabindex(swiper) {
    const focusableSelectors = 'a, button, input, textarea, select, [tabindex]';
    const totalSlides = swiper.slides.length;
    const slidesPerView = swiper.params.slidesPerView;
    if (swiper && totalSlides > slidesPerView) {
      swiper.slides.forEach((slide) => {
        slide.querySelectorAll(focusableSelectors).forEach((element) => element.setAttribute('tabindex', '-1'));
      });
      swiper.slides[swiper.activeIndex]?.querySelectorAll(focusableSelectors).forEach((element) => element.setAttribute('tabindex', element.hasAttribute('data-omit-tabindex') ? '-1' : '0'));
    } else {
      swiper.slides.forEach((slide) => {
        slide.querySelectorAll(focusableSelectors).forEach((element) => element.setAttribute('tabindex', element.hasAttribute('data-omit-tabindex') ? '-1' : '0'));
      });
    }
  }

  handleKeyboard(event) {
    const keyCode = event.keyCode || event.which;
    const focusedElement = document.activeElement;
    if (this.swiper && this.swiper.el.contains(focusedElement)) {
      switch (keyCode) {
        case 37:
          this.swiper.slidePrev();
          break;
        case 39:
          this.swiper.slideNext();
          break;
      }
    }
  }

  playSlider(event) {
    this.togglePlayPause(event.currentTarget.name);
    if (this.swiper) {
      this.swiper.params.autoplay.delay = this.autoplayDelayTime;
      this.swiper.autoplay.start();
    }
    this.classList.remove('theme-swiper--paused');
  }

  pauseSlider(event) {
    this.togglePlayPause(event.currentTarget.name);
    if (this.swiper) {
      this.swiper.params.autoplay.delay = 0;
      this.swiper.autoplay.stop();
    }
    this.classList.add('theme-swiper--paused');
  }

  togglePlayPause(state = 'play') {
    if (state == 'play') {
      this.playButton?.classList.add('hidden');
      this.pauseButton?.classList.remove('hidden');
    } else if (state == 'pause') {
      this.pauseButton?.classList.add('hidden');
      this.playButton?.classList.remove('hidden');
    }
  }

  updatePagination(swiper) {
    if (!swiper) return;
    const cloneSlides = swiper.el.querySelectorAll('.swiper-slide--cloned');
    if (cloneSlides.length === 0) return;
    const bullets = swiper.pagination.bullets;
    if (bullets.length <= 1) return;
    const index = swiper.realIndex - 1;
    const halfLength = Math.floor(bullets.length / 2);
    if (index >= halfLength - 1) {
      for (let i = 0; i < halfLength; i++) {
        bullets[i].style.display = 'none';
      }
    } else {
      for (let i = halfLength; i < bullets.length; i++) {
        bullets[i].style.display = 'none';
      }
    }
  }

  checkPagination(swiper) {
    let pagination = swiper.pagination;
    if (!pagination.el || pagination.bullets.length == 1) return;
    let breakpoint = [...this.breakpointList].find((breakpoint) => window.matchMedia(convertBreakpoint(breakpoint)).matches);
    this.classList.toggle('has-pagination', !pagination.el.classList.contains(`${breakpoint}-hide`));
  }

  checkNavigation(swiper) {
    let navigation = swiper.navigation;
    if (!navigation?.nextEl && !navigation?.prevEl) return;
    const nextDisabled = navigation.nextEl?.hasAttribute('disabled');
    const prevDisabled = navigation.prevEl?.hasAttribute('disabled');
    if (nextDisabled && prevDisabled) return;
    let breakpoint = [...this.breakpointList].find((breakpoint) => window.matchMedia(convertBreakpoint(breakpoint)).matches);
    this.classList.toggle('has-navigation', !navigation.nextEl.closest('.swiper-navigation').classList.contains(`${breakpoint}-hide`));
  }
}

customElements.define('theme-swiper', ThemeSwiper);

class ThemeSwiperPdp extends HTMLElement {
  constructor() {
    super();
    this._onVideoEnded = null;
    this.lastOutIndex = null;
    this.swiper = null;
    this.breakpointList = ['small', 'medium', 'large-up'];
    this.boundPlaySlider = this.playSlider.bind(this);
    this.boundPauseSlider = this.pauseSlider.bind(this);


    this.mainSwiper = null;
    this.thumbSwiper = null;

    // Bind methods to this
    this.initGallerySync = this.initGallerySync.bind(this);
    this.go = this.go.bind(this);
    this.setActive = this.setActive.bind(this);
    this._updateNavDisabled = this._updateNavDisabled.bind(this);
  }

  get container() {
    return this._container = this._container || this.querySelector('[data-swiper-container]') || this.querySelector('.swiper')
  }

  get wrapper() {
    return this._wrapper = this._wrapper || this.querySelector('[data-swiper-wrapper]') || this.querySelector('.swiper-wrapper')
  }

  get scrollbar() {
    return document.querySelector(`#Scrollbar-Slider-${this.dataset.sliderId}`) || this.querySelector('.swiper-scrollbar')
  }

  get pagination() {
    return document.querySelector(`#Pagination-Slider-${this.dataset.sliderId}`)
  }

  // get prev() {
  //   return document.querySelector(`#Navigation-Slider-${this.dataset.sliderId} .swiper-button-prev`) || this.querySelector('.swiper-button-prev')
  // }

  // get next() {
  //   return document.querySelector(`#Navigation-Slider-${this.dataset.sliderId} .swiper-button-next`) || this.querySelector('.swiper-button-next')
  // }

  get playButton() {
    return this.querySelector('.swiper-button-play')
  }

  get pauseButton() {
    return this.querySelector('.swiper-button-pause')
  }

  get resolution() {
    return this.getAttribute('data-resolution')
  }

  get autoplayDelayTime() {
    return parseInt(this.getAttribute('data-autoplay-delay'))
  }

  get items() {
    return this._items = this._items || Array.from(this.querySelectorAll('.swiper-slide'));
  }

  get markedItem() {
    return this._markedItem = this._markedItem || this.querySelector('.swiper-slide.swiper-slide-active [data-marked]');
  }

  connectedCallback() {
    if (!this.getAttribute('loaded')) {
      createObserver({
        element: this,
        callback: this.init.bind(this),
        threshold: -200
      });
    } else {
      this.init();
    }
    this.playButton?.addEventListener('click', this.boundPlaySlider);
    this.pauseButton?.addEventListener('click', this.boundPauseSlider);

    if (this.resolution) {
      const mq = window.matchMedia(this.resolution);
      this._resolutionListener = () => this.init();
      mq.addEventListener('change', this._resolutionListener);
    }


    this.initGallerySync();

    setTimeout(() => this._setThumbsHeight(), 300);
    window.addEventListener('resize', () => this._setThumbsHeight());

  }

  disconnectedCallback() {
    this.playButton?.removeEventListener('click', this.boundPlaySlider);
    this.pauseButton?.removeEventListener('click', this.boundPauseSlider);

    if (this.resolution && this._resolutionListener) {
      const mq = window.matchMedia(this.resolution);
      mq.removeEventListener('change', this._resolutionListener);
      this._resolutionListener = null;
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.swiper?.update();
    }
  }

  init() {
    this.options = this.swiperOptions();
    if (this.resolution != undefined) {
      if (window.matchMedia(this.resolution).matches) {
        if (!this.swiper) this.swiperInitilize();
      } else {
        if (this.swiper) this.swiperDestroy();
      }
    } else {
      if (!this.swiper) this.swiperInitilize();
    }
  }

  bindEvents() {
    if (!this.swiper) return;

    this._onSlideChange = () => {
      this.swiper.pagination.render();
      this.swiper.pagination.update();
      this.swiper.navigation.destroy();
      this.swiper.navigation.init();
      this.dispatchEvent(new CustomEvent('slider:change', {
        bubbles: true,
        detail: { currentPage: this.swiper.activeIndex }
      }));
    };

    this._onTransitionStart = () => {
      const oldIndex = this.swiper.previousIndex !== this.swiper.activeIndex
        ? this.swiper.previousIndex
        : this.lastOutIndex;
      const oldSlide = this.swiper.slides[oldIndex];
      if (oldSlide?.dataset.type === 'video') this.handleVideoOut(oldSlide, this.swiper);
      this.swiper.mousewheel.enabled = false;
      this.lastOutIndex = this.swiper.previousIndex;
    };

    this._onTransitionEnd = () => {
      const newSlide = this.swiper.slides[this.swiper.activeIndex];
      if (newSlide?.dataset.type === 'video') this.handleVideoIn(newSlide, this.swiper);
      this.swiper.mousewheel.enabled = true;
      this.lastOutIndex = this.swiper.activeIndex;
    };

    this._onPaginationUpdate = () => this.updatePagination(this.swiper);
    this._onSlideChangeTransitionEnd = () => this.handleLoop(this.swiper);

    this.swiper.on('slideChange', this._onSlideChange);
    this.swiper.on('transitionStart', this._onTransitionStart);
    this.swiper.on('transitionEnd', this._onTransitionEnd);
    this.swiper.on('paginationUpdate', this._onPaginationUpdate);
    this.swiper.on('slideChangeTransitionEnd', this._onSlideChangeTransitionEnd);
  }

  unBindEvents() {
    if (!this.swiper) return;

    this.swiper.off('slideChange', this._onSlideChange);
    this.swiper.off('transitionStart', this._onTransitionStart);
    this.swiper.off('transitionEnd', this._onTransitionEnd);
    this.swiper.off('paginationUpdate', this._onPaginationUpdate);
    this.swiper.off('slideChangeTransitionEnd', this._onSlideChangeTransitionEnd);

    this._onSlideChange = null;
    this._onTransitionStart = null;
    this._onTransitionEnd = null;
    this._onPaginationUpdate = null;
    this._onSlideChangeTransitionEnd = null;

    if (Shopify.designMode && this._onBlockSelect) {
      this.removeEventListener('shopify:block:select', this._onBlockSelect);
      this._onBlockSelect = null;
    }

    this.lastOutIndex = null;
  }

  swiperOptions() {
    let defaultOptions = {};
    try {
      defaultOptions = JSON.parse(this.dataset.swiper || '{}');
    } catch (e) {
      console.error('Invalid JSON in data-swiper:', e);
    }
    let options = { ...defaultOptions };
    options = {
      ...options,
      pagination: {
        el: this.pagination,
        clickable: true,
        renderBullet: (index, className) => {
          return `<span class="${className}">${index + 1}</span>`;
        }
      },
      navigation: {
        prevEl: this.prev,
        nextEl: this.next
      },
      scrollbar: {
        el: this.scrollbar,
        hide: false
      },
      a11y: {
        enabled: true
      },
      on: {
        init: (element) => {
          const selectedElement = element.slides[element.activeIndex];
          if (selectedElement && selectedElement.dataset.type === 'video') this.handleVideoIn(selectedElement, element);
          const indexInit = this.dataset.activeIndexInit;
          indexInit && this.setActiveSlideItem(indexInit);
          this.setSlideHeight();
          this.checkNavigation(element);
          this.checkPagination(element);
          this.updatePagination(element);
          element.slides.forEach((slide, index) => slide.setAttribute('data-index', index));
        },
        resize: (element) => {
          this.setSlideHeight();
          this.checkNavigation(element);
          this.checkPagination(element);
        },
        update: (element) => {
          this.setSlideHeight();
          this.checkNavigation(element);
          this.checkPagination(element);
        }
      }
    }

    return options
  }

  swiperInitilize() {
    if (!this.container.classList.contains('swiper')) this.container.classList.add('swiper');
    if (!this.wrapper.classList.contains('swiper-wrapper')) this.wrapper.classList.add('swiper-wrapper');
    this.querySelectorAll('[data-swiper-slide]').forEach((element) => {
      if (!element.classList.contains('swiper-slide')) element.classList.add('swiper-slide')
    });
    this.swiper = new Swiper(this.container, this.options);
    this.bindEvents();
  }

  swiperDestroy() {
    this.unBindEvents();
    this.swiper?.destroy(true, true);
    this.swiper = null;
    if (this.container.classList.contains('swiper')) this.container.classList.remove('swiper');
    if (this.wrapper.classList.contains('swiper-wrapper')) this.wrapper.classList.remove('swiper-wrapper');
    this.querySelectorAll('[data-swiper-slide]').forEach((element) => {
      if (element.classList.contains('swiper-slide')) element.classList.remove('swiper-slide')
    });
  }

  setActiveSlideItem(activeIndex) {
    if (typeof activeIndex == undefined) return;
    this.swiper && this.swiper.slideTo(activeIndex);
  }

  setSlideHeight() {
    if (!this.markedItem) return;
    this.style.setProperty('--slide-height', `${this.markedItem.offsetHeight}px`);
  }

  handleLoop(swiper) {
    if (swiper && swiper.params.loop) swiper.loopFix();
  }

  handleVideoOut(oldElement, swiper) {
    if (!oldElement) return;
    const videoElement = window.visibleMedia(oldElement.querySelectorAll('video-media'));
    if (!videoElement) return;
    videoElement.pause();
    videoElement.updateControlButton(true);
    videoElement.updateSoundButton(true);
    if (this._onVideoEnded) {
      videoElement.removeEventListener('video:ended', this._onVideoEnded);
      this._onVideoEnded = null;
    }
  }

  handleVideoIn(newElement, swiper) {
    if (!newElement) return;
    const videoElement = window.visibleMedia(newElement.querySelectorAll('video-media'));
    if (!videoElement) return;
    if (swiper.params.autoplay.enabled && swiper.autoplay.running) {
      // swiper.params.autoplay.delay = 0;
      swiper.autoplay.stop();
    }
    videoElement.play();
    videoElement.updateControlButton(false);
    videoElement.updateSoundButton(false);
    const handleVideoEnd = () => {
      this._onVideoEnded = null;
      videoElement.removeEventListener('video:ended', handleVideoEnd);
      if (swiper.params.autoplay.enabled && !swiper.autoplay.running) {
        swiper.autoplay.start();
        //  swiper.params.autoplay.delay = this.autoplayDelayTime;
        // swiper.slideNext();
      }
    };
    this._onVideoEnded = handleVideoEnd;
    videoElement.addEventListener('video:ended', this._onVideoEnded);
  }

  handleTabindex(swiper) {
    const focusableSelectors = 'a, button, input, textarea, select, [tabindex]';
    const totalSlides = swiper.slides.length;
    const slidesPerView = swiper.params.slidesPerView;
    if (swiper && totalSlides > slidesPerView) {
      swiper.slides.forEach((slide) => {
        slide.querySelectorAll(focusableSelectors).forEach((element) => element.setAttribute('tabindex', '-1'));
      });
      swiper.slides[swiper.activeIndex]?.querySelectorAll(focusableSelectors).forEach((element) => element.setAttribute('tabindex', element.hasAttribute('data-omit-tabindex') ? '-1' : '0'));
    } else {
      swiper.slides.forEach((slide) => {
        slide.querySelectorAll(focusableSelectors).forEach((element) => element.setAttribute('tabindex', element.hasAttribute('data-omit-tabindex') ? '-1' : '0'));
      });
    }
  }

  handleKeyboard(event) {
    const keyCode = event.keyCode || event.which;
    const focusedElement = document.activeElement;
    if (this.swiper && this.swiper.el.contains(focusedElement)) {
      switch (keyCode) {
        case 37:
          this.swiper.slidePrev();
          break;
        case 39:
          this.swiper.slideNext();
          break;
      }
    }
  }

  playSlider(event) {
    this.togglePlayPause(event.currentTarget.name);
    if (this.swiper) {
      this.swiper.params.autoplay.delay = this.autoplayDelayTime;
      this.swiper.autoplay.start();
    }
    this.classList.remove('theme-swiper--paused');
  }

  pauseSlider(event) {
    this.togglePlayPause(event.currentTarget.name);
    if (this.swiper) {
      this.swiper.params.autoplay.delay = 0;
      this.swiper.autoplay.stop();
    }
    this.classList.add('theme-swiper--paused');
  }

  togglePlayPause(state = 'play') {
    if (state == 'play') {
      this.playButton?.classList.add('hidden');
      this.pauseButton?.classList.remove('hidden');
    } else if (state == 'pause') {
      this.pauseButton?.classList.add('hidden');
      this.playButton?.classList.remove('hidden');
    }
  }

  updatePagination(swiper) {
    if (!swiper) return;
    const cloneSlides = swiper.el.querySelectorAll('.swiper-slide--cloned');
    if (cloneSlides.length === 0) return;
    const bullets = swiper.pagination.bullets;
    if (bullets.length <= 1) return;
    const index = swiper.realIndex - 1;
    const halfLength = Math.floor(bullets.length / 2);
    if (index >= halfLength - 1) {
      for (let i = 0; i < halfLength; i++) {
        bullets[i].style.display = 'none';
      }
    } else {
      for (let i = halfLength; i < bullets.length; i++) {
        bullets[i].style.display = 'none';
      }
    }
  }

  checkPagination(swiper) {
    let pagination = swiper.pagination;
    if (!pagination.el || pagination.bullets.length == 1) return;
    let breakpoint = [...this.breakpointList].find((breakpoint) => window.matchMedia(convertBreakpoint(breakpoint)).matches);
    this.classList.toggle('has-pagination', !pagination.el.classList.contains(`${breakpoint}-hide`));
  }

  checkNavigation(swiper) {
    let navigation = swiper.navigation;
    if (!navigation?.nextEl && !navigation?.prevEl) return;
    const nextDisabled = navigation.nextEl?.hasAttribute('disabled');
    const prevDisabled = navigation.prevEl?.hasAttribute('disabled');
    if (nextDisabled && prevDisabled) return;
    let breakpoint = [...this.breakpointList].find((breakpoint) => window.matchMedia(convertBreakpoint(breakpoint)).matches);
    this.classList.toggle('has-navigation', !navigation.nextEl.closest('.swiper-navigation').classList.contains(`${breakpoint}-hide`));
  }

  /**
   * Initialize gallery sync between main and thumbnail swipers
   */
  initGallerySync() {
    const isThumbHost = this.dataset.mainGallery !== undefined;
    if (!isThumbHost) return;

    const mainId = this.dataset.mainGallery;
    const mainHost = document.getElementById(mainId);
    if (!mainHost) return;

    this.thumbSwiper = this._ensureSwiper(this);
    this.mainSwiper = this._ensureSwiper(mainHost);
    if (!this.thumbSwiper || !this.mainSwiper) return;

    // Always disable loop to avoid duplicates/state issues.
    this.thumbSwiper.params.loop = false;
    this.mainSwiper.params.loop = false;

    // Cache navigation buttons INSIDE the thumbnail <theme-swiper>
    this.btnPrev = this.querySelector('.swiper-button-prev');
    this.btnNext = this.querySelector('.swiper-button-next');

    // Wire nav buttons
    if (this.btnPrev) {
      this.btnPrev.addEventListener('click', (e) => { e.preventDefault(); this.go(-1); });
    }
    if (this.btnNext) {
      this.btnNext.addEventListener('click', (e) => { e.preventDefault(); this.go(+1); });
    }

    // Click on thumbnail → activate that index
    this.thumbSwiper.slides.forEach((slide, idx) => {
      slide.addEventListener('click', () => this.setActive(idx));
    });

    // Main slide changed by swipe/keyboard → sync thumbnails + nav state
    this.mainSwiper.on('slideChange', () => {
      this.setActive(this.mainSwiper.activeIndex);
    });

    // IMPORTANT: when breakpoints/resize update direction to vertical/horizontal,
    // re-run the disabled state check.
    const refreshDisable = () => this._updateNavDisabled(this.mainSwiper.activeIndex ?? 0);
    this.thumbSwiper.on('breakpoint', refreshDisable);
    this.thumbSwiper.on('resize', refreshDisable);
    this.thumbSwiper.on('update', refreshDisable);
    this.thumbSwiper.on('slidesLengthChange', refreshDisable);

    // Lock main edges so drag beyond start/end won't change active
    this._lockMainEdges();

    // Initial state
    this.setActive(this.mainSwiper.activeIndex ?? 0);
  }

  /**
   * Utility: create Swiper instance if not exists
   */
  _ensureSwiper(themeSwiperEl) {
    const swiperEl = themeSwiperEl.querySelector('.swiper');
    if (!swiperEl) return null;
    if (swiperEl.swiper) return swiperEl.swiper;

    let cfg = {};
    try {
      cfg = JSON.parse(
        themeSwiperEl.getAttribute('data-swiper')
          .replace(/&quot;/g, '"')
          .replace(/(\r|\n)/g, ' ')
      );
    } catch (e) {
      console.warn('Cannot parse data-swiper config', e);
    }
    cfg.loop = false; // always no loop
    try {
      return new Swiper(swiperEl, cfg);
    } catch (e) {
      console.error('Failed to init Swiper', e);
      return null;
    }
  }

  /**
   * Move active index by delta (-1 for prev, +1 for next)
   */
  go(delta) {
    const total = this.mainSwiper.slides.length;
    const cur = this.mainSwiper.activeIndex ?? 0;
    let next = cur + delta;
    if (next < 0) next = 0;
    if (next > total - 1) next = total - 1;
    this.setActive(next);
  }

  /**
   * Set active slide on both main and thumb
   */
  setActive(index) {
    this.mainSwiper.slideTo(index, this.mainSwiper.params.speed || 300);
    this._markMainActive(index);
    this._markThumbActive(index);
    this._scrollThumbIntoView(index);

    // Update prev/next disabled state (only when vertical)
    this._updateNavDisabled(index);
  }

  /**
   * Mark active class for main gallery
   */
  _markMainActive(index) {
    const all = this.mainSwiper.el.querySelectorAll('.product__media-item');
    all.forEach(el => el.classList.remove('product__media-item--active'));
    const target = all[index];
    if (target) target.classList.add('product__media-item--active');
  }

  /**
   * Mark active class for thumbnails
   */
  _markThumbActive(index) {
    this.thumbSwiper.slides.forEach(s => s.classList.remove('is-active'));
    const t = this.thumbSwiper.slides[index];
    if (t) t.classList.add('is-active');
  }

  /**
   * Ensure active thumbnail is visible
   */
  _scrollThumbIntoView(index) {
    const sw = this.thumbSwiper;
    const spv = typeof sw.params.slidesPerView === 'number' ? sw.params.slidesPerView : 6;
    const center = Math.max(0, Math.min(index - Math.floor(spv / 2), sw.slides.length - spv));
    sw.slideTo(center, sw.params.speed || 300);
  }

  /**
   * Update prev/next buttons with disabled class when at edges
   */
  _updateNavDisabled(index) {
    if (!this.btnPrev || !this.btnNext || !this.mainSwiper) return;

    // Correct vertical detection:
    // - params.direction reflects current breakpoint
    // - class 'swiper-vertical' is also added by Swiper
    const thumbIsVertical =
      this.thumbSwiper?.params?.direction === 'vertical' ||
      this.thumbSwiper?.el?.classList?.contains('swiper-vertical');

    if (!thumbIsVertical) {
      // If horizontal, ensure buttons are enabled (no disabled class).
      this._toggleDisabled(this.btnPrev, false);
      this._toggleDisabled(this.btnNext, false);
      return;
    }

    // Reliable edge check with loop=false
    const total = this.mainSwiper.slides.length;
    const cur = (typeof index === 'number') ? index : (this.mainSwiper.activeIndex ?? 0);
    const atStart = cur <= 0;
    const atEnd = cur >= total - 1;

    this._toggleDisabled(this.btnPrev, atStart);
    this._toggleDisabled(this.btnNext, atEnd);
  }

  /**
   * Apply/remove disabled state (class + a11y attributes).
   */
  _toggleDisabled(btn, disabled) {
    btn.classList.toggle('is-disabled', !!disabled);
    btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    btn.tabIndex = disabled ? -1 : 0;
  }

  /**
   * Hard-lock edges so dragging past first/last won't advance active.
   * Works for mouse drag and touch.
   */
  _lockMainEdges() {
    const sw = this.mainSwiper;
    if (!sw) return;

    // Make sure loop & freeMode are off for predictable edges
    sw.params.loop = false;
    sw.params.freeMode = false;

    // Optional: remove rubber-banding feel at edges
    // (set to 0 only if you dislike the elastic effect)
    // sw.params.resistanceRatio = 0;

    // When we are at the end, disallow sliding further to the right (next)
    sw.on('reachEnd', () => { sw.allowSlideNext = false; });

    // When we are at the beginning, disallow sliding further to the left (prev)
    sw.on('reachBeginning', () => { sw.allowSlidePrev = false; });

    // When we move away from edges, re-allow both directions
    const reallow = () => {
      sw.allowSlideNext = true;
      sw.allowSlidePrev = true;
    };
    sw.on('fromEdge', reallow);
    sw.on('slideChange', reallow);
    sw.on('transitionEnd', () => {
      // Safety clamp in case anything tried to overshoot
      const last = sw.slides.length - 1;
      if (sw.activeIndex < 0) sw.slideTo(0, 0, false);
      if (sw.activeIndex > last) sw.slideTo(last, 0, false);
    });

    // Extra guard: if user is already at last and drags to the right, cancel next
    sw.on('touchStart', () => {
      const atEnd = sw.isEnd || sw.activeIndex === sw.slides.length - 1;
      const atStart = sw.isBeginning || sw.activeIndex === 0;
      sw.allowSlideNext = !atEnd;   // block dragging to the right if at end
      sw.allowSlidePrev = !atStart; // block dragging to the left if at start
    });
    sw.on('touchEnd', () => {
      // restore defaults after gesture
      sw.allowSlideNext = true;
      sw.allowSlidePrev = true;
    });
  }

  /**
   * Set thumbnails swiper height = main image height - (2 * button height)
   */
  _setThumbsHeight() {
    const mainImg = document.querySelector('.product-images--bottom-thumbnail .product-main-image');
    const thumbSwiper = document.querySelector('.product-images--bottom-thumbnail .product-thumbnail .swiper');
    const btnPrev = document.querySelector('.product-images--bottom-thumbnail .swiper-button-prev');
    const btnNext = document.querySelector('.product-images--bottom-thumbnail .swiper-button-next');

    if (!mainImg || !thumbSwiper) return;

    const mainH = mainImg.offsetHeight;
    const btnH = (btnPrev?.offsetHeight || 0);

    const newH = mainH - (btnH * 2);

    if (newH > 0) {
      thumbSwiper.style.height = `${newH}px`;
    }
  }


}

customElements.define('theme-swiper-pdp', ThemeSwiperPdp);


class TabComponent extends HTMLElement {
  constructor() {
    super();
  }

  get allItems() {
    return this._allItems = this._allItems || this.querySelectorAll('[data-filter]')
  }

  filtering(value) {
    if (value == 'all') {
      Array.from(this.allItems).forEach((item) => item.classList.remove('hidden'));
    } else {
      const items = this.querySelectorAll(`[data-filter=${value}]`);
      Array.from(this.allItems).forEach((item) => item.classList.add('hidden'));
      Array.from(items).forEach((item, index) => {
        item.classList.remove('hidden');
        if (index == 0) item.querySelector('button')?.click();
      });
    }
  }

  open(button, tab) {
    if (button) this.setActiveElement(button);
    const _targetTab = button.closest('li');
    if (_targetTab.classList.contains('active')) return;
    const _currentTab = this.querySelector(`li.active`);
    const _currentTabContent = this.querySelector(`.tab__content-item.active`);
    const _targetTabContent = this.querySelector(`[data-tab-id="${tab}"]`);
    this.load(_targetTabContent);
    _currentTab.classList.remove('active');
    _currentTabContent.classList.remove('active');
    _targetTab.classList.add('active');
    _targetTabContent.classList.add('active');
  }

  load(tab) {
    if (!tab.getAttribute('loaded')) {
      const content = tab.querySelector('template').content.cloneNode(true);
      tab.appendChild(content);
      tab.setAttribute('loaded', true);
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('tab-component', TabComponent);

class TemplateComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: 0
    });
  }

  init() {
    const template = this.querySelector('.template');
    if (!template) return;
    if (!this.getAttribute('loaded')) {
      template.replaceWith(template.content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);
    }
  }
}

customElements.define('template-component', TemplateComponent);

class VideoMedia extends DeferredMedia {
  constructor() {
    super();
  }

  playerTarget() {
    if (this.hasAttribute('host')) {
      this.setAttribute('loaded', '');
      this.classList.remove('loading');
      return new Promise(async (resolve) => {
        const templateElement = this.querySelector('template');
        if (templateElement) templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
        const muteVideo = this.hasAttribute('autoplay') || window.matchMedia('screen and (max-width: 1032px)').matches;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        if (this.getAttribute('host') === 'youtube') {
          if (!window.YT || !window.YT.Player) {
            script.src = 'https://www.youtube.com/iframe_api';
            document.head.appendChild(script);
            await new Promise((resolve2) => script.onload = resolve2);
          }
          await onYouTubePromise;
          const player = new YT.Player(this.querySelector('iframe'), {
            events: {
              onReady: () => {
                if (muteVideo) {
                  player.mute();
                  this.setAttribute('muted', '');
                }
                resolve(player);
              },
              onStateChange: (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  this.setAttribute('playing', '');
                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                  this.removeAttribute('playing');
                  if (event.data === YT.PlayerState.ENDED) {
                    this.dispatchEvent(new CustomEvent('video:ended', { bubbles: true }));
                  }
                }
                if (player.isMuted()) {
                  this.setAttribute('muted', '');
                } else {
                  this.removeAttribute('muted');
                }
              }
            }
          });
        }
        if (this.getAttribute('host') === 'vimeo') {
          if (!window.Vimeo || !window.Vimeo.Player) {
            script.src = 'https://player.vimeo.com/api/player.js';
            document.head.appendChild(script);
            await new Promise((resolve2) => script.onload = resolve2);
          }
          const player = new Vimeo.Player(this.querySelector('iframe'));
          if (muteVideo) {
            player.setMuted(true);
            this.setAttribute('muted', '');
          }
          player.on('play', () => this.setAttribute('playing', ''));
          player.on('pause', () => this.removeAttribute('playing'));
          player.on('ended', () => {
            this.removeAttribute('playing');
            this.dispatchEvent(new CustomEvent('video:ended', { bubbles: true }));
          });
          player.on('volumechange', () => {
            if (player.muted) {
              this.setAttribute('muted', '');
            } else {
              this.removeAttribute('muted');
            }
          });
          resolve(player);
        }
      });
    } else {
      this.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', '');
      this.classList.remove('loading');
      const player = this.querySelector('video');
      if (player.muted) this.setAttribute('muted', '');
      // Apply necessary attributes for Mobile Safari
      player.setAttribute('playsinline', ''); // required for mobile inline playback
      player.setAttribute('preload', 'auto'); // help preload
      // Preload immediately
      player.load();
      // Force autoplay for Safari/iOS
      if (player.muted && player.autoplay) {
        const tryPlay = player.play();
        if (tryPlay && typeof tryPlay.catch === 'function') {
          tryPlay.catch(() => {
            this.setAttribute('suspended', '');
            // player.controls = true;
          });
        }
      }
      player.addEventListener('play', () => {
        this.setAttribute('playing', '');
        this.removeAttribute('suspended');
      });
      player.addEventListener('pause', () => {
        if (!player.seeking && player.paused) this.removeAttribute('playing');
      });
      player.addEventListener('volumechange', () => {
        if (player.muted) {
          this.setAttribute('muted', '');
        } else {
          this.removeAttribute('muted');
        }
      });
      const handleEnd = () => {
        this.dispatchEvent(new CustomEvent('video:ended', { bubbles: true }));
      };
      const setupLoopDetection = () => {
        const onTimeUpdate = () => {
          const duration = player.duration;
          if (!isNaN(duration) && player.currentTime >= duration - 0.3) {
            player.removeEventListener('timeupdate', onTimeUpdate);
            handleEnd();
          }
        };
        player.addEventListener('timeupdate', onTimeUpdate);
      };

      if (player.loop) {
        if (isNaN(player.duration)) {
          player.addEventListener('loadedmetadata', setupLoopDetection, { once: true });
        } else {
          setupLoopDetection();
        }
      } else {
        player.addEventListener('ended', handleEnd);
      }
      return player;
    }
  }

  playerHandler(target, prop) {
    if (this.getAttribute('host') === 'youtube') {
      if (prop === 'play') {
        target.playVideo();
      } else if (prop === 'pause') {
        target.pauseVideo();
      } else if (prop === 'muted') {
        target.mute();
        this.setAttribute('muted', '');
      } else if (prop === 'unmuted') {
        target.unMute();
        this.removeAttribute('muted');
      }
    } else if (this.getAttribute('host') === 'vimeo') {
      if (prop === 'muted') {
        target.setMuted(true);
        this.setAttribute('muted', '');
      } else if (prop === 'unmuted') {
        target.setMuted(false);
        this.removeAttribute('muted');
      } else {
        target[prop]();
      }
    } else {
      if (prop === 'play' && !this.hasAttribute('host')) {
        target.play().catch((error) => {
          if (error.name === 'NotAllowedError') {
            this.setAttribute('suspended', '');
            target.controls = true;
          }
        });
      } else if (prop === 'muted' && !this.hasAttribute('host')) {
        target.muted = true;
      } else if (prop === 'unmuted' && !this.hasAttribute('host')) {
        target.muted = false;
      } else {
        target[prop]();
      }
    }
  }
}

customElements.define('video-media', VideoMedia);

if (Shopify.designMode) {
  document.addEventListener('shopify:block:select', () => {
    closeSideDrawer();
    hideModalDialog();
  });
  document.addEventListener('shopify:block:deselect', () => {
    closeSideDrawer();
    hideModalDialog();
  });
  document.addEventListener('shopify:section:load', () => {
    closeSideDrawer();
    hideModalDialog();
  });
  document.addEventListener('shopify:section:reorder', () => {
    closeSideDrawer();
    hideModalDialog();
  });
  document.addEventListener('shopify:section:select', () => {
    closeSideDrawer();
    hideModalDialog();
  });
  document.addEventListener('shopify:section:deselect', () => {
    closeSideDrawer();
    hideModalDialog();
  });
  document.addEventListener('shopify:inspector:activate', () => {
    closeSideDrawer();
    hideModalDialog();
  });
  document.addEventListener('shopify:inspector:deactivate', () => {
    closeSideDrawer();
    hideModalDialog();
  });
}


// Drag-to-scroll + edge controls for any element with [data-drag-scroll]
(() => {
  const THRESHOLD = 5;     // px: minimum movement to treat as a drag
  const CLEAR_DELAY = 120; // ms: keep "dragged" true briefly to block accidental clicks
  const EPS = 2;           // px: tolerance when detecting edges/overflow
  const DEFAULT_ARROW_STEP_RATIO = 0.85; // fraction of viewport width per click

  function initDragScroll(el) {
    if (!el || el.__dragScrollBound) return;
    el.__dragScrollBound = true;

    // --- Create arrow controls ---
    // NOTE: As requested:
    //  - <span class="is-on-right"> is inserted BEFORE the menu element.
    //  - <span class="is-on-left">  is inserted AFTER  the menu element.
    const leftCtrl = document.createElement('span');  // placed AFTER el
    leftCtrl.className = 'is-on-left';
    leftCtrl.setAttribute('role', 'button');
    leftCtrl.setAttribute('tabindex', '0');
    leftCtrl.setAttribute('aria-label', 'Scroll right');
    leftCtrl.dataset.ctrl = 'after';

    const rightCtrl = document.createElement('span');  // placed BEFORE el
    rightCtrl.className = 'is-on-right';
    rightCtrl.setAttribute('role', 'button');
    rightCtrl.setAttribute('tabindex', '0');
    rightCtrl.setAttribute('aria-label', 'Scroll left');
    rightCtrl.dataset.ctrl = 'before';

    // Insert in DOM at the requested positions
    el.insertAdjacentElement('beforebegin', rightCtrl);
    el.insertAdjacentElement('afterend', leftCtrl);

    // Optional: allow custom step via data attribute (pixels or ratio like "0.7x")
    const parseStep = () => {
      const attr = el.getAttribute('data-arrow-step');
      if (!attr) return el.clientWidth * DEFAULT_ARROW_STEP_RATIO;
      if (attr.endsWith('x')) {
        const r = parseFloat(attr);
        return isFinite(r) && r > 0 ? el.clientWidth * r : el.clientWidth * DEFAULT_ARROW_STEP_RATIO;
      }
      const px = parseFloat(attr);
      return isFinite(px) && px > 0 ? px : el.clientWidth * DEFAULT_ARROW_STEP_RATIO;
    };

    // --- Per-element drag state ---
    let isDown = false;
    let dragged = false;
    let startX = 0, startY = 0, startScrollLeft = 0;
    let clearDragTimer = null;

    // Touch/UX hints
    el.style.touchAction = 'pan-y'; // allow vertical page scroll; we handle horizontal drag
    el.style.cursor = 'grab';

    // --- Utilities ---
    const maxScrollX = () => Math.max(0, el.scrollWidth - el.clientWidth);
    const hasHorizontalOverflow = () => maxScrollX() > EPS;

    // Show/hide controls based on current edge
    function setEdgeFlags() {
      const maxX = maxScrollX();

      if (maxX <= EPS) {
        // Not horizontally scrollable → hide both controls
        hideCtrl(leftCtrl);
        hideCtrl(rightCtrl);
        el.dataset.edge = 'none';
        return;
      }

      const x = el.scrollLeft;
      const atLeft = x <= EPS;
      const atRight = x >= maxX - EPS;

      // Visibility logic:
      // - At left edge: there is content to the RIGHT → show the AFTER control (is-on-left), hide BEFORE
      // - At right edge: there is content to the LEFT  → show the BEFORE control (is-on-right), hide AFTER
      // - In middle: show BOTH
      if (atLeft && !atRight) {
        showCtrl(leftCtrl);
        hideCtrl(rightCtrl);
        el.dataset.edge = 'left';
      } else if (atRight && !atLeft) {
        showCtrl(rightCtrl);
        hideCtrl(leftCtrl);
        el.dataset.edge = 'right';
      } else {
        showCtrl(leftCtrl);
        showCtrl(rightCtrl);
        el.dataset.edge = 'middle';
      }
    }

    function applyInitialSide() {
      // Initial rule on page load:
      // If horizontally scrollable → start by showing the AFTER control only (like "is-on-left" when starting at left edge).
      if (hasHorizontalOverflow()) {
        showCtrl(leftCtrl);
        hideCtrl(rightCtrl);
        el.dataset.initialSide = 'left';
      } else {
        hideCtrl(leftCtrl);
        hideCtrl(rightCtrl);
        el.dataset.initialSide = 'none';
      }
    }

    // Control helpers (visibility without forcing author's CSS):
    function showCtrl(ctrl) {
      ctrl.classList.remove('hidden');
      ctrl.style.pointerEvents = 'auto';
      ctrl.style.opacity = '';
      ctrl.style.visibility = '';
      ctrl.hidden = false;
      ctrl.setAttribute('aria-hidden', 'false');
    }
    function hideCtrl(ctrl) {
      ctrl.classList.add('hidden');
      ctrl.style.pointerEvents = 'none';
      ctrl.style.opacity = '0';
      ctrl.style.visibility = 'hidden';
      ctrl.hidden = true;
      ctrl.setAttribute('aria-hidden', 'true');
    }

    // (Optional) Directional classes while dragging, based on pointer movement
    function updateDirectionClasses(dx, dy) {
      const mostlyHorizontal = Math.abs(dx) > Math.abs(dy);
      if (mostlyHorizontal && Math.abs(dx) > THRESHOLD) {
        if (dx > 0) {
          el.classList.add('is-dragging-right');
          el.classList.remove('is-dragging-left');
        } else {
          el.classList.add('is-dragging-left');
          el.classList.remove('is-dragging-right');
        }
      } else {
        el.classList.remove('is-dragging-left', 'is-dragging-right');
      }
    }

    function endDrag() {
      if (!isDown) return;
      isDown = false;

      el.classList.remove('is-dragging', 'is-dragging-left', 'is-dragging-right');
      el.style.cursor = 'grab';

      // Finalize edge state now and again on the next frame (to catch momentum)
      setEdgeFlags();
      requestAnimationFrame(setEdgeFlags);

      clearTimeout(clearDragTimer);
      clearDragTimer = setTimeout(() => { dragged = false; }, CLEAR_DELAY);
    }

    // --- Pointer events (drag-to-scroll) ---
    el.addEventListener('pointerdown', (e) => {
      isDown = true;
      dragged = false;
      startX = e.pageX;
      startY = e.pageY;
      startScrollLeft = el.scrollLeft;

      el.classList.add('is-dragging');
      el.style.cursor = 'grabbing';

      // Prevent text selection at drag start
      e.preventDefault();
    }, { passive: false });

    el.addEventListener('pointermove', (e) => {
      if (!isDown) return;

      const dx = e.pageX - startX;
      const dy = e.pageY - startY;

      if (!dragged && (Math.abs(dx) > THRESHOLD || Math.abs(dy) > THRESHOLD)) {
        dragged = true;
      }

      if (dragged) {
        // Follow pointer
        el.scrollLeft = startScrollLeft - dx;

        // Live updates
        updateDirectionClasses(dx, dy);
        setEdgeFlags();

        // Prevent vertical page scroll when primarily horizontal
        if (Math.abs(dx) > Math.abs(dy)) e.preventDefault();
      }
    }, { passive: false });

    el.addEventListener('pointerup', endDrag);
    el.addEventListener('pointercancel', endDrag);
    el.addEventListener('pointerleave', endDrag);

    // Keep controls in sync for inertia / scrollbar / programmatic scrolls
    el.addEventListener('scroll', setEdgeFlags, { passive: true });

    // --- Arrow control behavior ---
    const onArrowClick = (dir) => (e) => {
      // Block accidental clicks right after a drag
      if (dragged) { e.preventDefault(); return; }

      const step = parseStep();
      const delta = dir === 'left' ? -step : step;

      el.scrollBy({ left: delta, behavior: 'smooth' });
    };

    // "is-on-right" BEFORE the menu → scroll LEFT (reveal previous content)
    rightCtrl.addEventListener('click', onArrowClick('left'));
    rightCtrl.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onArrowClick('left')(e); }
    });

    // "is-on-left" AFTER the menu → scroll RIGHT (reveal next content)
    leftCtrl.addEventListener('click', onArrowClick('right'));
    leftCtrl.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onArrowClick('right')(e); }
    });

    // React to element size/content changes (images, fonts, responsive)
    if (window.ResizeObserver) {
      const ro = new ResizeObserver(() => {
        applyInitialSide();
        setEdgeFlags();
      });
      ro.observe(el);
    }

    // Also listen to viewport resize
    const onResize = () => {
      applyInitialSide();
      setEdgeFlags();
    };
    window.addEventListener('resize', onResize);

    // --- Initial run ---
    applyInitialSide();
    window.addEventListener('load', () => {
      applyInitialSide();
      setEdgeFlags();
    });
  }

  // Init on DOM ready
  const ready = () => {
    document.querySelectorAll('[data-drag-scroll]').forEach(initDragScroll);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})(); 

/* Fix invalid ProMap UL wrappers that have no LI children */
(function () {
    var PROMAP_SCOPE_SELECTOR = '[class*="scasl"], .scasl-container, .scasl-store-locator';
  
    function isInsideProMap(el) {
      return !!el.closest(PROMAP_SCOPE_SELECTOR);
    }
  
    function hasValidListItem(list) {
      return Array.prototype.some.call(list.children, function (child) {
        return child.tagName === 'LI' || child.getAttribute('role') === 'listitem';
      });
    }
  
    function shouldReplaceList(list) {
      if (!list) return false;
      if (!isInsideProMap(list)) return false;
      if (list.dataset.promapListFixed === 'true') return false;
  
      // Replace:
      // 1. completely empty UL
      // 2. UL has children but none are LI/listitem
      if (!list.children.length && !list.textContent.trim()) return true;
      if (list.children.length && !hasValidListItem(list)) return true;
  
      return false;
    }
  
    function replaceListWithDiv(list) {
      var replacement = document.createElement('div');
  
      Array.prototype.forEach.call(list.attributes, function (attr) {
        replacement.setAttribute(attr.name, attr.value);
      });
  
      while (list.firstChild) {
        replacement.appendChild(list.firstChild);
      }
  
      replacement.dataset.promapListFixed = 'true';
      list.parentNode.replaceChild(replacement, list);
    }
  
    function fixInvalidProMapLists(context) {
      var root = context && context.nodeType === 1 ? context : document;
  
      if (root.matches && root.matches('ul') && shouldReplaceList(root)) {
        // Rose perl comment replaceListWithDiv Apr 28, 2026
        // replaceListWithDiv(root);
      }
  
      root.querySelectorAll('ul').forEach(function (list) {
        if (shouldReplaceList(list)) {
          // Rose perl comment replaceListWithDiv Apr 28, 2026
          // replaceListWithDiv(list);
        }
      });
    }
  
    function init() {
      fixInvalidProMapLists(document);
  
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            fixInvalidProMapLists(node);
          });
        });
      });
  
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
